<div class="loader">
  <div></div>
  <div></div>
  <div></div>
  <i>{{name}}</i>
</div>
